export const enum SettingsType {
    SUPERADMIN,
    ORGADMIN,
    TEAMSADMIN,
    PROFILE,
    PROJECT,
}
